import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoaderserviceService {
  constructor() {}
  isLoading = new Subject<boolean>();
  showGlobalHeader = new BehaviorSubject<boolean>(true);

  show() {
    this.isLoading.next(true);
  }
  hide() {
    this.isLoading.next(false);
  }

  turnOffGlobalLoader() {
    this.showGlobalHeader.next(false);
  }
  turnOnGlobalLoader() {
    this.showGlobalHeader.next(true);
  }
}
